import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04efcc75"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "test_version_304",
  style: {"visibility":"hidden"}
}, null, -1))
const _hoisted_2 = { class: "problem" }
const _hoisted_3 = {
  class: "flex abormal-flex",
  style: {"padding-top":"10px"}
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = {
  key: 1,
  class: "content"
}
const _hoisted_7 = { class: "shopping-item name 11" }
const _hoisted_8 = {
  key: 2,
  class: "content"
}
const _hoisted_9 = { class: "shopping-item name" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex abormal-flex" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "content rel" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "abs big-img"
}
const _hoisted_21 = { class: "tag-content" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "flex abormal-flex"
}
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "content rel" }
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 0,
  class: "abs big-img"
}
const _hoisted_28 = { class: "tag-content" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "abnormal-measure-size-content"
}
const _hoisted_31 = {
  key: 0,
  class: "abnormal-measure-size-item"
}
const _hoisted_32 = { class: "item-title" }
const _hoisted_33 = { class: "size-content" }
const _hoisted_34 = { class: "name" }
const _hoisted_35 = { class: "num" }
const _hoisted_36 = {
  key: 1,
  class: "abnormal-measure-size-item"
}
const _hoisted_37 = { class: "item-title" }
const _hoisted_38 = { class: "size-content" }
const _hoisted_39 = { class: "name" }
const _hoisted_40 = { class: "num" }
const _hoisted_41 = {
  key: 2,
  class: "flex abormal-flex"
}
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "content" }
const _hoisted_44 = { class: "flex abormal-flex" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { class: "content" }
const _hoisted_47 = {
  key: 3,
  class: "form",
  style: {"padding":"20px 0 0 0","border-top":"1px solid #F9F9F9"}
}
const _hoisted_48 = {
  key: 0,
  class: "title isgroupTitle"
}
const _hoisted_49 = { class: "tip" }
const _hoisted_50 = {
  key: 1,
  class: "title isgroupTitle",
  style: {"margin":"30px 0 10px 0"}
}
const _hoisted_51 = {
  key: 2,
  class: "small_quick_tip"
}
const _hoisted_52 = { style: {"font-weight":"700"} }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("ありOEM生産履歷がないため、仕入をキャンセルのう元、OEM見積もり依頼へ進むことを推奨いたします。 ")
const _hoisted_54 = { key: 4 }
const _hoisted_55 = { style: {"width":"100%"} }
const _hoisted_56 = { style: {"width":"100%"} }
const _hoisted_57 = { style: {"width":"100%"} }
const _hoisted_58 = { style: {"width":"100%"} }
const _hoisted_59 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap"}
}
const _hoisted_60 = {
  key: 0,
  style: {"color":"red","font-size":"12px"}
}
const _hoisted_61 = { style: {"max-width":"600px","font-size":"14px"} }
const _hoisted_62 = {
  class: "line--only",
  style: {"width":"100%","max-width":"600px"}
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  key: 1,
  class: "flex-col"
}
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = {
  key: 1,
  style: {"color":"red","font-size":"12px","padding-bottom":"6px"}
}
const _hoisted_67 = { class: "rel" }
const _hoisted_68 = {
  key: 0,
  class: "check-sku abs"
}
const _hoisted_69 = { key: 2 }
const _hoisted_70 = { key: 3 }
const _hoisted_71 = {
  key: 6,
  style: {"padding-top":"20px","margin-top":"20px","border-top":"1px solid #f9f9f9"},
  class: "flex-col"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  style: {"margin-left":"20px"},
  class: "rel"
}
const _hoisted_76 = {
  key: 0,
  class: "check-sku abs"
}
const _hoisted_77 = {
  style: {"display":"flex","flex-wrap":"wrap"},
  class: "flex-col"
}
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = { style: {"max-width":"600px","font-size":"14px"} }
const _hoisted_80 = {
  class: "line--only",
  style: {"width":"100%","max-width":"600px"}
}
const _hoisted_81 = { key: 1 }
const _hoisted_82 = ["innerHTML"]
const _hoisted_83 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_84 = ["href"]
const _hoisted_85 = { key: 2 }
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_88 = { key: 3 }
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = { key: 4 }
const _hoisted_91 = ["innerHTML"]
const _hoisted_92 = { key: 5 }
const _hoisted_93 = ["innerHTML"]
const _hoisted_94 = {
  key: 6,
  style: {"padding-top":"20px","margin-top":"20px","border-top":"1px solid #f9f9f9"}
}
const _hoisted_95 = { class: "title" }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = {
  key: 4,
  class: "flex-col abormal-flex",
  style: {"padding-bottom":"10px","border-top":"1px solid #F9F9F9","padding-top":"20px"}
}
const _hoisted_99 = { class: "isgroupTitle" }
const _hoisted_100 = {
  class: "content",
  style: {"background":"#FCFCFC","padding":"15px 10px","min-height":"90px"}
}
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { key: 2 }
const _hoisted_104 = ["innerHTML"]
const _hoisted_105 = ["innerHTML"]
const _hoisted_106 = { key: 3 }
const _hoisted_107 = { key: 4 }
const _hoisted_108 = { key: 5 }
const _hoisted_109 = { key: 6 }
const _hoisted_110 = { key: 7 }
const _hoisted_111 = { key: 8 }
const _hoisted_112 = { key: 9 }
const _hoisted_113 = ["innerHTML"]
const _hoisted_114 = ["href"]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 10 }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 11 }
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = ["href"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { key: 12 }
const _hoisted_125 = ["innerHTML"]
const _hoisted_126 = ["href"]
const _hoisted_127 = { key: 13 }
const _hoisted_128 = ["innerHTML"]
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_130 = { key: 15 }
const _hoisted_131 = ["innerHTML"]
const _hoisted_132 = { key: 16 }
const _hoisted_133 = ["innerHTML"]
const _hoisted_134 = { key: 17 }
const _hoisted_135 = { key: 18 }
const _hoisted_136 = { key: 19 }
const _hoisted_137 = { key: 20 }
const _hoisted_138 = { key: 21 }
const _hoisted_139 = {
  key: 0,
  class: "el-dialog__body-footer flex-ter-end"
}
const _hoisted_140 = {
  key: 1,
  style: {"text-align":"center","padding-top":"10px","padding-bottom":"10px"}
}
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-dialog__body-title" }, null, -1))
const _hoisted_142 = { class: "warning mb_10" }
const _hoisted_143 = ["src"]
const _hoisted_144 = { style: {"margin-top":"40px","text-align":"right"} }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-dialog__body-title" }, null, -1))
const _hoisted_146 = { class: "small-quick-detail-table" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "ckb-sku-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "customer-sku-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "product-spec-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "quantity-column" })
], -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "THE CKB SKU", -1))

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed, onUnmounted, nextTick, onMounted } from 'vue'
import AppLink from '@/components/common/AppLink.vue'
import SniffDrawer from '@/components/common/SniffDrawer.vue'
import productTable from './components/productTable.vue'
import { problemHandling, backendProduct, backendProductSku, searchAll, getUserPurchaseAbnormalExtentApi, getUserPurchaseAbnormalPdd, getPlatformOrderItem, getAbnormalDetailApi } from '@/apis/order'
import CarouselImg from './CarouselImg.vue'
import { ElMessage } from 'element-plus'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { WarningFilled, Warning } from '@element-plus/icons-vue'
import { isD2C, isJA, useUser } from '@/store'
import ProductSku from './components/ProductSku.vue'
import AbnormalGoodsTip from '@/components/common/AbnormalGoodsTip.vue'
import { abnormalDegreeDescList, tagsMap } from '@/common/const'
import { handleResult } from './index'
import confirmDialog from '@/components/common/ConfirmDialog'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { useStore } from 'vuex'
import { request } from '@/config/request/interceptors'
import type { CheckQuickResponseRespDTO, Sku } from '@/service/purchase'
import EditMeasureSize from '@/views/product/Stock/components/EditMeasureSize/index.vue'
import { checkSpecialInboundRequirementCustomerApi, getMeasureWhiteListApi } from '@/apis/goods'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  onlyRead: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'refresh', 'editSuccess'],
  setup(__props, { emit: emits }) {

const props = __props


const skuSelectOptions = [
  {
    label: 'このSKUのみキャンセル',
    value: '1'
  }, {
    label: '全SKUをキャンセル',
    value: '2'
  }
]
const smallQuickSkuType = ref('1')



const warningIcon = require('@/assets/image/icon/warning_red.png')
const isHaveShopPurchase = ref(0)
const productSellPrice = ref('')
const showSku = ref(false)
// PDD数据
const originalPricePDD = ref()
const groupBookingPricePdd = ref()
const goodNumPDD = ref()
const userChooseConfirmOriginalPrice = ref()

const store = useStore()
const isZhaotian = computed(() => store.getters.user?.superCustomerId === '7' || store.getters.user?.superCustomerId === '34039')

const user = useUser()

// 商务仓以上
const isExceed3 = () => user.membership?.templateLevel >= 3

watch(() => props.visible, (newValue) => {
  if (newValue) {
    init()
    smallQuickResult.value = {}
    if ([2, 8].includes(props.rowItem.type) && isD2C() && isExceed3()) {
      checkSmallQuick()
    }
    if ([1, 2, 3].includes(props.rowItem.abnormalDetailType)) {
      getBackendProduct()
    }
    if ([4, 5].includes(props.rowItem.abnormalDetailType)) {
      getBackendProductSku()
    }
    if (props.rowItem.type === 8 || props.rowItem.type === 12 || props.rowItem.type === 10) {
      // 获取状态和价格
      getUserPurchaseAbnormalExtentApi({
        purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId
      }).then((res: any) => {
        isHaveShopPurchase.value = res.data.isHaveShopPurchase
        productSellPrice.value = res.data.productSellPrice
      })
    }
    // 进入PDD流程
    if (props.rowItem.abnormalDetailType === 14 && props.rowItem.type === 1) {
      getUserPurchaseAbnormalPdd({
        purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId
      }).then((res: any) => {
        originalPricePDD.value = res.data.originalPrice
        groupBookingPricePdd.value = res.data.groupBookingPrice
        goodNumPDD.value = res.data.goodNum
        userChooseConfirmOriginalPrice.value = res.data.userChooseConfirmOriginalPrice
      })
    }
  } else {
    smallQuickDetailVisible.value = false
    removeSmallQuickReturnListener()
  }
})

// 小单快反查询结果
const smallQuickResult = ref<CheckQuickResponseRespDTO>()

/** 小单快反 SKU 详情弹窗是否显示。 */
const smallQuickDetailVisible = ref(false)

/** 打开小单快反 SKU 详情弹窗。 */
const openSmallQuickDetail = () => {
  smallQuickDetailVisible.value = true
}

/** 关闭小单快反 SKU 详情弹窗。 */
const closeSmallQuickDetail = () => {
  smallQuickDetailVisible.value = false
}

/** 合并小单快反 SKU 的颜色和尺码规格。 */
const formatSmallQuickProductSpec = (sku: Sku) => {
  return [sku.color, sku.size].filter(Boolean).join(' / ') || '-'
}

// 查询是否可以发起小单快反
const checkSmallQuick = async () => {
  const res = await request.purchase.user.purchaseAbnormalCheckQuickResponse({ purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId })
  smallQuickResult.value = res.data
}

// 获取采购商品详情
const getBackendProductSku = () => {
  const { purchaseUserProductSku } = toRaw(props.rowItem)
  backendProductSku({
    productSku: purchaseUserProductSku
  }).then((res: any) => {
    for (const e of (res.data.skuList || [])) {
      if (e.productSku === purchaseUserProductSku) {
        console.log('e', e)
        const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
        checkedProduct.value = {
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl,
          price: e.productSellPrice
        }
        break
      }
    }
  })
}
const getBackendProduct = () => {
  const { productCode, productSku } = toRaw(props.rowItem)
  backendProduct({
    productCode
  }).then(res => {
    const list = (res.data.skuList || []).map((e: any) => {
      const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
      if (e.productSku === productSku) {
        checkedProduct.value = {
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl
        }
      }
      return ({
        productSku: e.productSku,
        productCode: e.productCode,
        props: properties.join(' '),
        link: res.data.productDetailUrl
      })
    })
    productSkuList.value = list
  })
}

const showSearch = ref(false)
const searchLoading = ref(false)

const getList = (type?: boolean) => {
  return new Promise((resolve) => {
    const fn = () => {
      searchAll({ detailUrl: customerProductLink.value }).then(res => {
        resolve(res)
      })
    }
    type ? setTimeout(fn, 500) : fn()
  })
}
const productInfo: any = ref({})
const cb = async (type?: boolean) => {
  const res: any = await getList(type)
  if (res.success) {
    productInfo.value = res.data
    if (res.data?.skuList.length) {
      searchSkuList.value = (res.data.skuList || []).map((e: any) => {
        const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
        return ({
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl
        })
      })
    } else {
      const bool = true
      await cb(bool)
    }
  }
}

const searchUrl = async () => {
  if (!customerProductLink.value) return ElMessage.warning(t('请输入链接'))
  searchLoading.value = true
  try {
    await cb()
    showSearch.value = true
    searchLoading.value = false
  } catch (error) {
    searchLoading.value = false
  }
}

const imgList = computed(() => {
  return props.rowItem.imageList?.length > 0 ? props.rowItem.imageList : [{ image: props.rowItem.productImg }]
})

const ztImgs = computed(() => {
  return props.rowItem.ztImg ? props.rowItem.ztImg?.split(',')?.map(i => {
    return { image: i }
  }) : []
})

const checkedProduct: any = ref()
const productSkuList: any = ref([])
const searchSkuList: any = ref([])

const customerOperateType = ref()
const customerProductLink = ref()
const customerProductSku = ref()
const payRepurchaseType = ref(true)
watch(() => customerOperateType, () => {
  showSearch.value = true
})

const init = () => {
  checkedProduct.value = {}
  productSkuList.value = []
  searchSkuList.value = []
  customerOperateType.value = ''
  customerProductLink.value = ''
  customerProductSku.value = ''
  payRepurchaseType.value = true
  toEditShopPurchase.value = false
  originalPricePDD.value = ''
  groupBookingPricePdd.value = ''
  goodNumPDD.value = ''
  userChooseConfirmOriginalPrice.value = ''
  isTotalFinish.value = false
  showSearch.value = false
  tableData.value = []
  groupVisible.value = false
  // groupAbnormal.value = ''

  getGroupData()
}

const getParams = () => {
  if (customerOperateType.value === 4) {
    if (!customerProductLink.value) {
      ElMessage.warning(t('请输入链接'))
      return false
    }
  }
  const { purchaseAbnormalOrderId, purchaseUserProductLink, purchaseUserProductSku, customerProductProp } = toRaw(props.rowItem)
  const obj: any = {
    purchaseAbnormalOrderId,
    customerOperateType: customerOperateType.value
  }
  if (customerOperateType.value === 5) {
    return obj
  }
  // 更换 颜色尺码款式时 取消商品不传sku 其他都需要传sku
  if ([1, 2, 3].includes(customerOperateType.value)) {
    const v = productSkuList.value.find((e: any) => e.productSku === customerProductSku.value)
    obj.customerProductLink = v?.link ?? ''
    obj.customerProductSku = v?.productSku ?? ''
    obj.customerProductProp = v?.props ?? ''
    return obj
  }
  if (customerOperateType.value === 4 || customerOperateType.value === 15) {
    const v = searchSkuList.value.find((e: any) => e.productSku === customerProductSku.value)
    obj.customerProductLink = v?.link ?? ''
    obj.customerProductSku = v?.productSku ?? ''
    obj.customerProductProp = v?.props ?? ''
    return obj
  }
  if ([6, 7].includes(customerOperateType.value)) {
    obj.customerProductSku = purchaseUserProductSku
    obj.customerProductLink = purchaseUserProductLink
    obj.customerProductProp = customerProductProp
    return obj
  }
  // showDefectiveProduct和组合直发单有重合 是组合直发的话不return
  if (showDefectiveProduct.value && !isgroup.value) {
    if (props.rowItem.payRepurchaseType !== 1 && payRepurchaseType.value) {
      obj.payRepurchaseType = isD2C() ? 1 : 2
    }
    return obj
  }
  if (props.rowItem.abnormalDetailType === 14) {
    obj.purchaseSkuRespDTO = {
      userChooseConfirmOriginalPrice: userChooseConfirmOriginalPrice.value
    }
  }
  if (isgroup.value && customerOperateType.value === 18) {
    obj.itemDetails = tableData.value.filter((f: any) => !(f.orderItemStatusList.map((v: any) => v.orderItemStatus).some((v: any) => [8, 9, 10, 12].includes(v)) || f.orderType === 2 || f.cancelStatus === 4)).map((v: any) => {
      return {
        purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId,
        platformOrderNo: props.rowItem.platformOrderNo,
        platformOrderItemId: v.platformOrderItemId,
        productSku: v.productSku,
        productName: v.productTitle,
        productImg: v.productSkuImg,
        productLink: v.productDetailUrl,
        productProp: v.productPropertiesName,
        num: v.orderQuantity,
        dealType: v.dealType
      }
    })
    // 兼容showDefectiveProduct
    // if (props.rowItem.payRepurchaseType !== 1 && payRepurchaseType.value) {
    //   obj.payRepurchaseType = 1
    // }
  }
  return obj
}
const locationOrigin = computed(() => {
  return window.location.origin
})
let firstParams: any = ''
const toEditShopPurchase = ref(false)
const isTotalFinish = ref(false) // 是否重拍上限

/** 用户从小单快反页面切回当前页面后，重新检查是否仍可创建小单快反。 */
const checkSmallQuickAfterReturning = async () => {
  await checkSmallQuick()
  if (!props.visible) return
  if (smallQuickResult.value?.quickResponseAllowed === true) return
  removeSmallQuickReturnListener()
  ElMessage.success(t('申请成功'))
  emits('update:visible', false)
  emits('refresh')
}

/** 移除当前页面重新获得焦点时的小单快反检查事件。 */
const removeSmallQuickReturnListener = () => {
  window.removeEventListener('focus', checkSmallQuickAfterReturning)
}

/** 注册当前页面重新获得焦点时的小单快反检查事件。 */
const registerSmallQuickReturnListener = () => {
  removeSmallQuickReturnListener()
  console.log('我触发了')

  window.addEventListener('focus', checkSmallQuickAfterReturning)
}

/** 组件卸载时移除小单快反页面返回监听。 */
onUnmounted(removeSmallQuickReturnListener)

const submit = async (isSmallQuick = false) => {
  if (!customerOperateType.value) return ElMessage.warning(t('请选择处理方式'))
  const params: any = getParams()
  if (params) {
    if (params.customerOperateType === 15 && !params.customerProductLink) {
      return ElMessage.warning(t('请输入链接'))
    }
    if ([4, 15].includes(params.customerOperateType) && params.customerProductLink) {
      // 判断输入的链接和当前商品国家是否一致
      if (productInfo.value.country !== props.rowItem.supplierCountry) {
        confirmDialog({
          title: t('异常提示'),
          text: t('不能添加不同国家的货品')
        })
        return
      }
    }
    if ([4, 15].includes(params.customerOperateType) && !params.customerProductSku) {
      return ElMessage.warning(t('商品バリエーションを選択してください'))
    }

    // 不需要判断是否配置10.31需求
    // if (props.rowItem.type === 8 && isHaveShopPurchase.value === 0 && !toEditShopPurchase.value && getParams().customerOperateType === 12) {
    //   // 异常 没有配置&& 不良品 跳转配置
    //   toEditShopPurchase.value = true
    //   firstParams = JSON.parse(JSON.stringify(getParams()))
    //   return
    // }
    // 不需要判断是否配置10.31需求
    // if (params.customerOperateType === 6) {
    //   // 同款链接加link和sku字段
    //   params.customerProductSku = props.rowItem.productSku
    //   params.customerProductLink = props.rowItem.productLink
    // }
    if (smallQuickResult.value?.quickResponseAllowed && isSmallQuick) {
      sessionStorage.setItem(`purchaseAbnormalOrderId_${props.rowItem.purchaseAbnormalOrderId}`, JSON.stringify(getParams()))
      registerSmallQuickReturnListener()
      nextTick(() => {
        /** 打开的小单快反页面窗口。 */
        window.open(`${locationOrigin.value}/oem/smallOrderQuickResponse/productionGoods?purchaseAbnormalOrderId=${props.rowItem.purchaseAbnormalOrderId}&smallQuickSkuType=${customerOperateType.value === 5 ? smallQuickSkuType.value : 1}`)
      })
      return
    }
    problemHandling(firstParams || params).then((res: any) => {
      if (res.success) {
        if (firstParams) {
          problemHandling(getParams()).then((res: any) => {
            ElMessage.success(t('申请成功'))
            emits('update:visible', false)
            emits('refresh')
          })
        } else {
          ElMessage.success(t('申请成功'))
          emits('update:visible', false)
          emits('refresh')
        }
        firstParams = ''
        toEditShopPurchase.value = false
      } else {
        console.log(res)
        if (res.code === '20000023') {
          // 重拍上限
          isTotalFinish.value = true
          customerOperateType.value = ''
          return
        }
        if (res.code === '200000046') {
          confirmDialog({
            title: t('异常提示'),
            text: t('不能添加不同国家的货品')
          })
        }
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }
}

const showDefectiveProduct = computed(() => {
  //  7 次品件
  return props.rowItem.type === 7
})

const showAbnormalParts = computed(() => {
  // 8 异常件
  return props.rowItem.type === 8
})

const showContentList = computed(() => {
  const { type, abnormalDetailType, userExpected, remark, purchaseUserProductLink, changeLinkSellPrice } = props.rowItem
  // ("type 异常类型 1 商品确认 2 全网断货 3 原商品缺货 4 预售商品 5 不满足最小起订量 6 更换采购链接 7 次品件 8 异常次品件 9 客户退款 10 到错货 11 多件 12 少件 13 扫不出 14 商品下架 15 商品异常")
  switch (type) {
    case 1:
      switch (abnormalDetailType) {
        case 1:
          return [t('确认尺码')]
        case 2:
          return [t('确认颜色')]
        case 3:
          return [t('确认款式')]
        case 14:
          return [t('无法按拼团价进行采购，需按原价进行采购')]
        default:
          return []
      }
    case 2:
      return [t('全网断货')]
    case 3:
      switch (abnormalDetailType) {
        case 4:
          return !userExpected ? [t('原商品缺货-推荐同款-价格不符合客户预期').replace('X', checkedProduct.value.price ?? 0).replaceAll('H', purchaseUserProductLink)] : []
        case 5:
          return [t('原商品缺货-推荐类似款').replace('X', checkedProduct.value.price ?? 0).replaceAll('H', purchaseUserProductLink)]
        default:
          return []
      }
    case 4:
      switch (abnormalDetailType) {
        case 4:
          return [t('预售商品-推荐同款商品').replace('X', remark ?? 0).replaceAll('H', purchaseUserProductLink)]
        case 6:
          return [t('预售商品-无同款商品推荐').replace('X', remark ?? 0)]
        default:
          return []
      }
    case 5:
      switch (abnormalDetailType) {
        case 4:
          return [t('不满足最小起量-推荐同款商品').replace('X', remark ?? 0).replace('Y', props.rowItem.num).replaceAll('H', purchaseUserProductLink)]
        case 6:
          return [t('不满足最小起量-无同款商品推荐').replace('X', remark ?? 0).replace('Y', props.rowItem.num)]
        default:
          return []
      }
    case 6:
      return !userExpected ? [t('更换同款链接-价格不符合客户预期').replaceAll('H', purchaseUserProductLink)] : []
    case 7:
    case 8:
      return getDefectiveProductContent()
    case 10:
      // 未配置次品付费重拍和配置文案区分
      return [(isHaveShopPurchase.value === 0 ? t('因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍') : t('因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认')).replace('X', productSellPrice.value).replaceAll('H', purchaseUserProductLink)]
    case 12:
      return [t('原URL缺货，新的URL内商品是X元，请确认').replace('X', productSellPrice.value).replaceAll('H', purchaseUserProductLink)]
    default:
      return []
  }
})

const getDefectiveProductContent = () => {
  const { abnormalDetailMessageJp } = props.rowItem
  const content: string[] = []
  abnormalDetailMessageJp?.split(',')?.forEach((e: string) => {
    content.push(defectiveAbnormalDict.value[e] || '')
  })
  // console.log('111', t('$色差$'))
  return content
}

const getAbnormalType = computed(() => {
  const { abnormalDetailMessageJp } = props.rowItem
  const isShow = abnormalDetailMessageJp?.split(',')?.some((value: number) => value > 300)
  return isShow
})

// 仓库次品登记
const defectiveAbnormalDictFlaw: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$'),
  302: t('$污渍/斑点/水印$'),
  303: t('$破损$'),
  304: t('$线头$'),
  305: t('$接缝不良$'),
  306: t('$抽丝$'),
  307: t('$针眼$'),
  308: t('$霉菌$'),
  309: t('$生锈$'),
  310: t('$商品有中文$'),
  311: t('$纽扣破损$'),
  312: t('$拉链破损$'),
  313: t('$附属品缺陷$'),
  314: t('$有气味$'),
  315: t('$其他不良$'),
  316: t('$通电不良$'),
  317: t('尺码差异2'),
  318: t('配件差异2'),
  319: t('设计差异2'),
  320: t('染色不良'),
  321: t('抽绳不良')
}

// 仓库异常上报客户
const defectiveAbnormalDictAbnormal: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$2'),
  302: t('$污渍/斑点/水印$2'),
  303: t('$破损$2'),
  304: t('$线头$2'),
  305: t('$接缝不良$2'),
  306: t('$抽丝$2'),
  307: t('$针眼$2'),
  308: t('$霉菌$2'),
  309: t('$生锈$2'),
  310: t('$商品有中文$2'),
  311: t('$纽扣破损$2'),
  312: t('$拉链破损$2'),
  313: t('$附属品缺陷$2'),
  314: t('$有气味$2'),
  315: t('$其他不良$2'),
  316: t('$通电不良$2'),
  317: t('尺码差异2'),
  318: t('配件差异2'),
  319: t('设计差异2'),
  320: t('染色不良'),
  321: t('抽绳不良')
}

const defectiveAbnormalDict = computed(() => {
  return props.rowItem.type === 8 ? defectiveAbnormalDictAbnormal : defectiveAbnormalDictFlaw
})

//  翻译转换
const cT = computed(() => {
  const { type, orderType, customerOperateType } = props.rowItem
  const defaultObj: any = {
    取消商品: t('取消商品采购'), // 囤货
    换个链接: t('请在我指定的新链接下采购'),
    同款链接: t('请在THE CKB为我推荐的此链接下采购'),
    等待原链接: t('可以等待，请继续在原链接采购'),
    类似款链接: t('请在THE CKB为我推荐的此链接下采购'),
    下单原链接: t('我接受起订量，请继续在原链接采购'),
    '下单原链接（多出数量保留库存）': t('我接受起订量，请继续在原链接采购'),
    良品入库: t('问题不大，我能接受，请当成良品入库'),
    不良品: t('此问题我不能接受，请依然当成不良品处理')
  }
  defaultObj['取消商品'] = orderType === 2 ? t('取消商品采购') : t('取消商品采购+商品发送')
  // 商品确认
  if (type === 1) {
    defaultObj['换个链接'] = t('请在我指定的新链接购买')
  }
  // 全网断货
  if (type === 2) {
    defaultObj['换个链接'] = t('我有可能有货的采购链接，请在这个链接再尝试购买')
  }
  // 预售商品
  if (type === 4) {
    defaultObj['换个链接'] = t('我等不及，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我等不及，请在THE CKB为我推荐的此链接下采购')
  }
  // 不满足最小起订量
  if (type === 5) {
    defaultObj['换个链接'] = t('我不接受起订量，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我不接受起订量，请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）')
  }
  // 更换同款链接
  if (type === 6) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我还是要继续在原链接采购')
  }
  // 次品
  if (type === 7) {
    defaultObj['取消商品'] = orderType === 2 ? t('次品退货退款并取消商品采购') : t('次品退货退款并取消商品采购+商品发送')
    if (customerOperateType !== 0) {
      // 异常处理完查看详情type 8 会转为7
      defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
      defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
    }
  }
  // 异常
  if (type === 8) {
    defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
    defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
  }
  // 倒错货
  if (type === 10) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  // 少件
  if (type === 12) {
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  return (t: any) => {
    return defaultObj[t]
  }
})

// 组合直发
// 处理是isgroup 结果是isgroup_result   isgroup_result增加了transformStockStatus入口
const isgroup = computed(() => {
  //      是否直发      是否重拍               采购配置              重拍上限           仓库异常   客户配置         是否是转成囤货单
  const { orderType, purchaseRemakeStatus, purchaseOperateType, reachMaxRemakeTimes, type, payRepurchaseType, transformStockStatus } = props.rowItem
  // if (orderType !== 1 && transformStockStatus !== 1) {
  if (orderType !== 1) {
    return false
  }
  if (type === 7 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 7 && payRepurchaseType === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 0) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  if (type === 10 && reachMaxRemakeTimes === 1 && purchaseRemakeStatus === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && payRepurchaseType === 2 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 10 && purchaseRemakeStatus === 2 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  return false
})
const isgroupResult = computed(() => {
  //      是否直发      是否重拍               采购配置              重拍上限           仓库异常   客户配置         是否是转成囤货单
  const { orderType, purchaseRemakeStatus, purchaseOperateType, reachMaxRemakeTimes, type, payRepurchaseType, transformStockStatus } = props.rowItem
  if (orderType !== 1 && transformStockStatus !== 1) {
    return false
  }
  if (type === 7 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '$次品重拍达到上限$'
  }
  if (type === 7 && payRepurchaseType === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 0) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  if (type === 10 && reachMaxRemakeTimes === 1 && purchaseRemakeStatus === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && payRepurchaseType === 2 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 10 && purchaseRemakeStatus === 2 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  return false
})
const groupVisible = ref(false)
const radioGroupChange = (e) => {
  if (e !== 4) {
    groupVisible.value = true
  }
}
const tableData = ref([])
const getGroupData = () => {
  if (!isgroup.value) {
    return
  }
  if (props.onlyRead) {
    getAbnormalDetailApi({ purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId }).then(res => {
      if (res.success) {
        res.data.itemDetails.forEach((v: any) => {
          v.productMainImg = v.productImg
          v.productPropertiesName = v.productProp
          v.orderQuantity = v.num
          v.orderItemStatusList = []
        })
        tableData.value = res.data.itemDetails
      }
    })
  } else {
    getPlatformOrderItem({ platformOrderId: props.rowItem.platformOrderId, source: 2 }).then(res => {
      if (res.success) {
        res.data.forEach((v: any) => {
          v.dealType = 1
        })
        tableData.value = res.data
      }
    })
  }
}

const close = () => {
  emits('update:visible', false)
}

const translateDegree = (key: any) => {
  return abnormalDegreeDescList[key]
}
const currentUnit = computed(() => showCurrentUnit(props.rowItem.supplierCountry === COUNTRY.KR))
const editMeasureSizeRef = ref()
const updateSize = () => {
  editMeasureSizeRef.value.open({
    id: props.rowItem.productSku,
    comType: 2,
    productMeasureDtoList: props.rowItem.actualContentList ?? []
  })
}
// 尺寸测量白名单
const isMeasuerWhite = ref(false)
// 特殊入库要求白名单
const isSpecialWhite = ref(false)
onMounted(() => {
  // 查询尺寸测量白名单信息
  getMeasureWhiteListApi({}).then((res) => {
    isMeasuerWhite.value = res.data?.includes(store.getters.user?.customerId)
  })
  checkSpecialInboundRequirementCustomerApi({
    customerId: store.getters.user?.customerId
  }).then((res) => {
    isSpecialWhite.value = res.data
  })
})

return (_ctx: any,_cache: any) => {
  const _component_block = _resolveComponent("block")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SniffDrawer, {
      drawer: __props.visible,
      onClose: close,
      title: props.title
    }, {
      drawerFoot: _withCtx(() => [
        (!__props.onlyRead)
          ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
              _createVNode(_component_el_button, {
                style: {"width":"100px","height":"40px"},
                onClick: _cache[43] || (_cache[43] = ($event: any) => (emits('update:visible', false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                style: {"width":"100px","height":"40px"},
                type: "primary",
                onClick: _cache[44] || (_cache[44] = ($event: any) => (submit(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
                ]),
                _: 1
              }),
              (smallQuickResult.value?.quickResponseAllowed)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "small-quick-submit-button",
                    type: "primary",
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (submit(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('確定、小ロット生産見積依頼へ')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.onlyRead)
          ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[46] || (_cache[46] = ($event: any) => (emits('update:visible', false))),
                style: {"width":"200px","height":"40px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('商品问题原因')), 1),
            (__props.rowItem.abnormalDetailMessageSeverity?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItem.abnormalDetailMessageSeverity, (i, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(translateDegree(i.abnormalCode)) + " - " + _toDisplayString(translateDegree(i.abnormalSeverityCode)), 1))
                  }), 128)),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('※多次更换变成了同样的不良品。即使重新更换也没有改善不良品的可能性(因为是批量生产)。不良在容许范围内的情况下，建议允许入库')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('※问题商品数量多，交货期延迟的可能性大。不良在容许范围内的情况下，建议允许入库')), 1)
                ]))
              : (_unref(isgroupResult))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)(_unref(isgroupResult)).replace('元', _unref(currentUnit))), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showContentList), (l) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: l,
                          style: {"margin":"0"}
                        }, [
                          _createElementVNode("span", {
                            innerHTML: l.replace('元', _unref(currentUnit)),
                            style: {"word-break":"break-all","line-height":"1.5"}
                          }, null, 8, _hoisted_10)
                        ]))
                      }), 128)),
                      (_unref(getAbnormalType) && !__props.onlyRead)
                        ? (_openBlock(), _createBlock(_component_block, { key: 0 }, {
                            default: _withCtx(() => [
                              (__props.rowItem.type === 7 && _unref(isJA)())
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "",
                                    innerHTML: _unref(t)('请在下方选择重新购买或取消指示')
                                  }, null, 8, _hoisted_11))
                                : _createCommentVNode("", true),
                              (__props.rowItem.type === 7)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "pt20 red",
                                    innerHTML: _unref(t)('为不超过次品退货期限次品默认退货')
                                  }, null, 8, _hoisted_12))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (__props.rowItem.abnormalDetailType === 14)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)('原价')) + ": " + _toDisplayString(originalPricePDD.value) + " " + _toDisplayString(_unref(currentUnit)), 1))
                      : _createCommentVNode("", true),
                    _hoisted_14,
                    (__props.rowItem.abnormalDetailType === 14)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)('拼团价')) + ": " + _toDisplayString(groupBookingPricePdd.value), 1))
                      : _createCommentVNode("", true)
                  ]))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('异常图片')), 1),
            _createElementVNode("div", _hoisted_18, [
              (_unref(imgList)?.length > 1)
                ? (_openBlock(), _createBlock(CarouselImg, {
                    key: 0,
                    imgs: _unref(imgList)
                  }, null, 8, ["imgs"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(imgList)[0].image)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _unref(imgList)[0].image,
                          target: "_blank",
                          class: "rel prew-img"
                        }, [
                          _createVNode(_component_el_image, {
                            referrerPolicy: "no-referrer",
                            class: "shopping-img",
                            lazy: "",
                            "data-goods": "",
                            src: _unref(imgList)[0].image
                          }, null, 8, ["src"]),
                          (_unref(imgList)[0]?.image)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgList)[0].tags, (tagItem) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "tag",
                                      key: tagItem
                                    }, _toDisplayString(_unref(tagsMap)[tagItem]), 1))
                                  }), 128))
                                ]),
                                _createElementVNode("img", {
                                  referrerPolicy: "no-referrer",
                                  src: _unref(imgList)[0]?.image,
                                  alt: ""
                                }, null, 8, _hoisted_22)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(SvgIcon, {
                            name: "放大",
                            class: "abs icon1",
                            style: {"bottom":"4px","right":"4px","font-size":"20px"}
                          }),
                          _createVNode(SvgIcon, {
                            name: "放大_active",
                            class: "abs icon2",
                            style: {"bottom":"4px","right":"4px","font-size":"20px"}
                          })
                        ], 8, _hoisted_19))
                      : _createCommentVNode("", true)
                  ], 64))
            ])
          ]),
          (_unref(isZhaotian) && !!_unref(ztImgs)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('客户shopify销售图')), 1),
                _createElementVNode("div", _hoisted_25, [
                  (_unref(ztImgs)?.length > 1)
                    ? (_openBlock(), _createBlock(CarouselImg, {
                        key: 0,
                        imgs: _unref(ztImgs)
                      }, null, 8, ["imgs"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(ztImgs)?.[0]?.image)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _unref(ztImgs)?.[0]?.image,
                              target: "_blank",
                              class: "rel prew-img"
                            }, [
                              _createVNode(_component_el_image, {
                                referrerPolicy: "no-referrer",
                                class: "shopping-img",
                                lazy: "",
                                "data-goods": "",
                                src: _unref(ztImgs)?.[0]?.image
                              }, null, 8, ["src"]),
                              (_unref(ztImgs)?.[0]?.image)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ztImgs)?.[0]?.tags, (tagItem) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "tag",
                                          key: tagItem
                                        }, _toDisplayString(_unref(tagsMap)[tagItem]), 1))
                                      }), 128))
                                    ]),
                                    _createElementVNode("img", {
                                      referrerPolicy: "no-referrer",
                                      src: _unref(ztImgs)?.[0]?.image,
                                      alt: ""
                                    }, null, 8, _hoisted_29)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(SvgIcon, {
                                name: "放大",
                                class: "abs icon1",
                                style: {"bottom":"4px","right":"4px","font-size":"20px"}
                              }),
                              _createVNode(SvgIcon, {
                                name: "放大_active",
                                class: "abs icon2",
                                style: {"bottom":"4px","right":"4px","font-size":"20px"}
                              })
                            ], 8, _hoisted_26))
                          : _createCommentVNode("", true)
                      ], 64))
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.rowItem?.abnormalDetailMessageJp?.includes('205'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (__props.rowItem.standardContentList?.length && isSpecialWhite.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('标准尺寸')) + "(CM)", 1),
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItem.standardContentList, (i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "size-item",
                            key: i
                          }, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)(i.name)) + "：", 1),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(i.value), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.actualContentList?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('实际测量尺寸')) + "(CM)", 1),
                        (isMeasuerWhite.value)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "item-a",
                              onClick: updateSize
                            }, _toDisplayString(_unref(t)('更新新商品测量数据')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItem.actualContentList, (i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "size-item",
                            key: i
                          }, [
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)(i.name)) + "：", 1),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(i.value), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.rowItem.allIncludeFlag !== 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('商品单价')), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(Number(__props.rowItem.productSellPrice).toFixed(__props.rowItem.supplierCountry === _unref(COUNTRY).KR ? 0 : 2) ?? '-') + " " + _toDisplayString(_unref(currentUnit)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(t)('异常数量')), 1),
            _createElementVNode("div", _hoisted_46, _toDisplayString(__props.rowItem.num || 0), 1)
          ]),
          (!__props.onlyRead)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (!_unref(isgroup))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createTextVNode(_toDisplayString(toEditShopPurchase.value ? _unref(t)('不良品') : '') + " " + _toDisplayString(_unref(t)('请选择处理方式')), 1),
                      _createElementVNode("span", _hoisted_49, "（" + _toDisplayString(_unref(t)('只可选择一种')) + "）", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('订单详情')), 1)
                    ])),
                (smallQuickResult.value?.quickResponseAllowed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createVNode(_component_el_icon, {
                        style: {"margin-right":"8px"},
                        color: "#0586FE"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Warning))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" 当該商品(全SKU)「" + _toDisplayString(__props.rowItem.type == 8 ? _unref(t)('不良品') : _unref(t)('在庫切れ')) + "」が合計", 1),
                      _createElementVNode("span", _hoisted_52, _toDisplayString(smallQuickResult.value?.totalNum) + "点", 1),
                      _hoisted_53,
                      _createElementVNode("button", {
                        type: "button",
                        class: "small_quick_tip_detail",
                        onClick: openSmallQuickDetail
                      }, "詳細")
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isgroup))
                  ? (_openBlock(), _createBlock(productTable, {
                      key: 3,
                      tableData: tableData.value,
                      style: {"margin":"0 auto 20px auto","height":"300px"},
                      long: true
                    }, null, 8, ["tableData"]))
                  : _createCommentVNode("", true),
                (_unref(isgroup))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createVNode(_component_el_radio_group, {
                        modelValue: customerOperateType.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerOperateType).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_55, [
                            (props.rowItem?.customerOptionList?.includes(16))
                              ? (_openBlock(), _createBlock(_component_el_radio, {
                                  key: 0,
                                  label: 16,
                                  onClick: radioGroupChange
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）正常发货')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            (props.rowItem?.customerOptionList?.includes(17))
                              ? (_openBlock(), _createBlock(_component_el_radio, {
                                  key: 0,
                                  label: 17,
                                  onClick: radioGroupChange
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            (props.rowItem?.customerOptionList?.includes(18))
                              ? (_openBlock(), _createBlock(_component_el_radio, {
                                  key: 0,
                                  label: 18,
                                  onClick: radioGroupChange
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            (props.rowItem?.customerOptionList?.includes(4))
                              ? (_openBlock(), _createBlock(_component_el_radio, {
                                  key: 0,
                                  label: 4
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('该商品不取消采购和发货，在我指定的新链接继续购买')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (customerOperateType.value === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _withDirectives(_createElementVNode("span", null, [
                              _createVNode(_component_el_input, {
                                modelValue: customerProductLink.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerProductLink).value = $event)),
                                placeholder: _unref(t)('请输入链接(必填)'),
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (showSearch.value = false)),
                                style: {"width":"300px"}
                              }, null, 8, ["modelValue", "placeholder"]),
                              _createVNode(_component_el_button, {
                                loading: searchLoading.value,
                                class: "rel",
                                type: "primary",
                                style: {"margin-left":"6px","top":"-2px"},
                                onClick: searchUrl
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ], 512), [
                              [_vShow, customerOperateType.value === 4]
                            ]),
                            (_unref(isJA)())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, " ここに入力するリンクは、必ず元のリンクの商品と同じ商品でお願いします "))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("div", null, [
                              _createVNode(AbnormalGoodsTip, {
                                style: {"margin":"10px 0"},
                                "product-code": searchSkuList.value && searchSkuList.value[0]?.productCode,
                                product: productInfo.value
                              }, null, 8, ["product-code", "product"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSkuList.value, (v) => {
                                return (_openBlock(), _createBlock(_component_el_button, {
                                  style: {"margin":"6px"},
                                  type: v.productSku === customerProductSku.value ? 'primary' : 'default',
                                  key: v.productSku,
                                  onClick: ($event: any) => (customerProductSku.value = v.productSku)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "light",
                                      placement: "top",
                                      "popper-class": "tool-tip-no-border"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_61, _toDisplayString(v.props), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_62, _toDisplayString(v.props), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "onClick"]))
                              }), 128))
                            ], 512), [
                              [_vShow, showSearch.value]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_unref(showAbnormalParts) && !toEditShopPurchase.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_el_radio, {
                            modelValue: customerOperateType.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerOperateType).value = $event)),
                            label: 11
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(cT)('良品入库')), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        (__props.rowItem.customerOptionList.includes(19))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_63, [
                              _createVNode(_component_el_radio, {
                                modelValue: customerOperateType.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customerOperateType).value = $event)),
                                label: 19
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        (__props.rowItem.type === 8 && !isTotalFinish.value && !__props.rowItem.customerOptionList.includes(19))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              (!props.rowItem.needHideChangeUrl)
                                ? (_openBlock(), _createBlock(_component_el_radio, {
                                    key: 0,
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 15,
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (customerProductSku.value = ''))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _unref(cT)('换个链接')
                                      }, null, 8, _hoisted_65)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("span", null, [
                                _createVNode(_component_el_input, {
                                  modelValue: customerProductLink.value,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customerProductLink).value = $event)),
                                  placeholder: _unref(t)('请输入链接(必填)'),
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (showSearch.value = false)),
                                  style: {"width":"300px"}
                                }, null, 8, ["modelValue", "placeholder"]),
                                _createVNode(_component_el_button, {
                                  loading: searchLoading.value,
                                  class: "rel",
                                  style: {"margin-left":"6px","top":"-2px"},
                                  onClick: searchUrl,
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ], 512), [
                                [_vShow, customerOperateType.value === 15]
                              ]),
                              (_unref(isJA)() && customerOperateType.value === 15)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, " ここに入力するリンクは、必ず元のリンクの商品と同じ商品でお願いします "))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("div", _hoisted_67, [
                                _createVNode(AbnormalGoodsTip, {
                                  style: {"margin":"10px 0"},
                                  "product-code": searchSkuList.value && searchSkuList.value[0]?.productCode,
                                  product: productInfo.value
                                }, null, 8, ["product-code", "product"]),
                                _createVNode(_component_el_button, {
                                  style: {"width":"100%","height":"36px"},
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (showSku.value = !showSku.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((searchSkuList.value.filter((v) => v.productSku === customerProductSku.value)[0]?.props) || _unref(t)('请选择')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_Transition, { name: "el-zoom-in-top" }, {
                                  default: _withCtx(() => [
                                    (showSku.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                          _createVNode(ProductSku, {
                                            skuList: searchSkuList.value,
                                            onChange: _cache[10] || (_cache[10] = (sku) => { customerProductSku.value = sku }),
                                            onClose: _cache[11] || (_cache[11] = ($event: any) => (showSku.value = false)),
                                            checkSku: customerProductSku.value
                                          }, null, 8, ["skuList", "checkSku"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ], 512), [
                                [_vShow, showSearch.value]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (__props.rowItem.type === 8)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_69, [
                              (!__props.rowItem.customerOptionList.includes(19))
                                ? (_openBlock(), _createBlock(_component_el_radio, {
                                    key: 0,
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 5
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                              (smallQuickResult.value?.quickResponseAllowed&&customerOperateType.value==5)
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 1,
                                    modelValue: smallQuickSkuType.value,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((smallQuickSkuType).value = $event)),
                                    style: {"width":"240px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skuSelectOptions, (item) => {
                                        return _createVNode(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"])
                                      }), 64))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_70, [
                              _createVNode(_component_el_radio, {
                                modelValue: customerOperateType.value,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((customerOperateType).value = $event)),
                                label: 12
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(cT)('不良品')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                      ], 64))
                    : (_unref(showDefectiveProduct) || toEditShopPurchase.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createVNode(_component_el_radio, {
                            modelValue: customerOperateType.value,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((customerOperateType).value = $event)),
                            label: 13
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X',
              __props.rowItem.remakeMoney || 0)) + ")", 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (__props.rowItem.payRepurchaseType !== 1 && (customerOperateType.value === 13))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_72, [
                                _createVNode(_component_el_checkbox, {
                                  disabled: !(customerOperateType.value === 13),
                                  modelValue: payRepurchaseType.value,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((payRepurchaseType).value = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(isD2C)() ? _unref(t)('以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。') : _unref(t)('以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。')
                                    }, null, 8, _hoisted_73)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_radio, {
                            modelValue: customerOperateType.value,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((customerOperateType).value = $event)),
                            label: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (smallQuickResult.value?.quickResponseAllowed&&customerOperateType.value==5)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: smallQuickSkuType.value,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((smallQuickSkuType).value = $event)),
                                style: {"width":"240px"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skuSelectOptions, (item) => {
                                    return _createVNode(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"])
                                  }), 64))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (__props.rowItem.abnormalDetailType === 14 && __props.rowItem.type === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            _createElementVNode("p", null, [
                              _createVNode(_component_el_radio, {
                                modelValue: customerOperateType.value,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((customerOperateType).value = $event)),
                                label: 14
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('按原价采购')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_el_radio, {
                                modelValue: customerOperateType.value,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((customerOperateType).value = $event)),
                                label: 5
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (smallQuickResult.value?.quickResponseAllowed)
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 0,
                                    modelValue: smallQuickSkuType.value,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((smallQuickSkuType).value = $event)),
                                    style: {"width":"240px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skuSelectOptions, (item) => {
                                        return _createVNode(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"])
                                      }), 64))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                            ([1, 2, 3].includes(__props.rowItem.abnormalDetailType))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  (__props.rowItem.abnormalDetailType === 1)
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 0,
                                        modelValue: customerOperateType.value,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((customerOperateType).value = $event)),
                                        label: 2,
                                        onClick: _cache[23] || (_cache[23] = ($event: any) => (customerProductSku.value = __props.rowItem.productSku))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('更换尺码')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  (__props.rowItem.abnormalDetailType === 2)
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 1,
                                        modelValue: customerOperateType.value,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((customerOperateType).value = $event)),
                                        label: 1,
                                        onClick: _cache[25] || (_cache[25] = ($event: any) => (customerProductSku.value = __props.rowItem.productSku))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('更换颜色')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  (__props.rowItem.abnormalDetailType === 3)
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 2,
                                        modelValue: customerOperateType.value,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((customerOperateType).value = $event)),
                                        label: 3,
                                        onClick: _cache[27] || (_cache[27] = ($event: any) => (customerProductSku.value = __props.rowItem.productSku))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('更换款式')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _withDirectives(_createElementVNode("div", _hoisted_75, [
                                    _createVNode(_component_el_button, {
                                      style: {"width":"350px","height":"36px"},
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (showSku.value = !showSku.value))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((productSkuList.value.filter((v) => v.productSku === customerProductSku.value)[0]?.props) || _unref(t)('请选择')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
                                      default: _withCtx(() => [
                                        (showSku.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                              _createVNode(ProductSku, {
                                                skuList: productSkuList.value,
                                                onChange: _cache[29] || (_cache[29] = (sku) => { customerProductSku.value = sku }),
                                                onClose: _cache[30] || (_cache[30] = ($event: any) => (showSku.value = false)),
                                                checkSku: customerProductSku.value
                                              }, null, 8, ["skuList", "checkSku"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ], 512), [
                                    [_vShow, [1, 2, 3].includes(customerOperateType.value)]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_radio, {
                                modelValue: customerOperateType.value,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((customerOperateType).value = $event)),
                                label: 5
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (smallQuickResult.value?.quickResponseAllowed&&customerOperateType.value==5)
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 0,
                                    modelValue: smallQuickSkuType.value,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((smallQuickSkuType).value = $event)),
                                    style: {"width":"240px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skuSelectOptions, (item) => {
                                        return _createVNode(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"])
                                      }), 64))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_el_radio, {
                                modelValue: customerOperateType.value,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((customerOperateType).value = $event)),
                                label: 4,
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (customerProductSku.value = ''))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _unref(cT)('换个链接')
                                  }, null, 8, _hoisted_78)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createVNode(_component_el_input, {
                                  modelValue: customerProductLink.value,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((customerProductLink).value = $event)),
                                  placeholder: _unref(t)('请输入链接(必填)'),
                                  onChange: _cache[36] || (_cache[36] = ($event: any) => (showSearch.value = false)),
                                  style: {"width":"300px"}
                                }, null, 8, ["modelValue", "placeholder"]),
                                _createVNode(_component_el_button, {
                                  loading: searchLoading.value,
                                  class: "rel",
                                  type: "primary",
                                  style: {"margin-left":"6px","top":"-2px"},
                                  onClick: searchUrl
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ], 512), [
                                [_vShow, customerOperateType.value === 4]
                              ]),
                              _withDirectives(_createElementVNode("div", null, [
                                _createVNode(AbnormalGoodsTip, {
                                  style: {"margin":"10px 0"},
                                  "product-code": searchSkuList.value && searchSkuList.value[0]?.productCode,
                                  product: productInfo.value
                                }, null, 8, ["product-code", "product"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSkuList.value, (v) => {
                                  return (_openBlock(), _createBlock(_component_el_button, {
                                    style: {"margin":"6px"},
                                    type: v.productSku === customerProductSku.value ? 'primary' : 'default',
                                    key: v.productSku,
                                    onClick: ($event: any) => (customerProductSku.value = v.productSku)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_tooltip, {
                                        effect: "light",
                                        placement: "top",
                                        "popper-class": "tool-tip-no-border"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_79, _toDisplayString(v.props), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("p", _hoisted_80, _toDisplayString(v.props), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["type", "onClick"]))
                                }), 128))
                              ], 512), [
                                [_vShow, showSearch.value]
                              ])
                            ]),
                            (__props.rowItem.abnormalDetailType === 4 || __props.rowItem.abnormalDetailType === 7)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                  _createVNode(_component_el_radio, {
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 6
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _unref(cT)('同款链接')
                                      }, null, 8, _hoisted_82)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  (__props.rowItem.purchaseUserProductLink)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                        _createElementVNode("a", {
                                          target: "_blank",
                                          href: __props.rowItem.purchaseUserProductLink
                                        }, _toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ")", 9, _hoisted_84),
                                        _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (__props.rowItem.abnormalDetailType === 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  _createVNode(_component_el_radio, {
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 7
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _unref(cT)('类似款链接')
                                      }, null, 8, _hoisted_86)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  (__props.rowItem.purchaseUserProductLink)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                        _createVNode(AppLink, {
                                          to: __props.rowItem.purchaseUserProductLink,
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ") ", 1)
                                          ]),
                                          _: 1
                                        }, 8, ["to"]),
                                        _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (__props.rowItem.type === 4)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                  _createVNode(_component_el_radio, {
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _unref(cT)('等待原链接')
                                      }, null, 8, _hoisted_89)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            ((__props.rowItem.type === 6) || (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 4))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _createVNode(_component_el_radio, {
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _unref(cT)('下单原链接')
                                      }, null, 8, _hoisted_91)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 6)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                  _createVNode(_component_el_radio, {
                                    modelValue: customerOperateType.value,
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((customerOperateType).value = $event)),
                                    label: 10
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _unref(cT)('下单原链接（多出数量保留库存）')
                                      }, null, 8, _hoisted_93)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            ((__props.rowItem.type === 10) && [4, 6].includes(customerOperateType.value) && isHaveShopPurchase.value === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                  _createElementVNode("div", _hoisted_95, _toDisplayString(_unref(t)('请确认本次重拍费用')), 1),
                                  _createElementVNode("p", null, [
                                    _createVNode(_component_el_radio, {
                                      "model-value": 13,
                                      label: 13
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X',
                __props.rowItem.remakeMoney
                ||
                0)) + ")", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (__props.rowItem.payRepurchaseType !== 1 && (customerOperateType.value === 13))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_96, [
                                        _createVNode(_component_el_checkbox, {
                                          disabled: !(customerOperateType.value === 13),
                                          modelValue: payRepurchaseType.value,
                                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((payRepurchaseType).value = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              innerHTML: _unref(isD2C)() ? _unref(t)('以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。') : _unref(t)('以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。')
                                            }, null, 8, _hoisted_97)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('处理结果')), 1)
                ]),
                _createElementVNode("div", _hoisted_100, [
                  (__props.rowItem.customerOperateType == 11)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(_unref(cT)('良品入库')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 12)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_unref(cT)('不良品')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 13)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_103, [
                        _createTextVNode(_toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X', __props.rowItem.remakeMoney
              || 0)) + ") ", 1),
                        (__props.rowItem.payRepurchaseType === 1 && _unref(isD2C)())
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              innerHTML: _unref(t)('以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。')
                            }, null, 8, _hoisted_104))
                          : _createCommentVNode("", true),
                        (__props.rowItem.payRepurchaseType === 2 && !_unref(isD2C)())
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              innerHTML: _unref(t)('以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。')
                            }, null, 8, _hoisted_105))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 5)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_unref(cT)('取消商品')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 14)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_unref(t)('按原价采购')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(_unref(t)('更换尺码')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(_unref(t)('更换颜色')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(_unref(t)('更换款式')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 14)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(_unref(t)('按原价采购')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 15)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                        _createElementVNode("span", {
                          innerHTML: _unref(cT)('换个链接')
                        }, null, 8, _hoisted_113),
                        _createElementVNode("a", {
                          href: __props.rowItem.customerProductLink,
                          target: "_blank"
                        }, "(" + _toDisplayString(__props.rowItem.customerProductLink) + ")", 9, _hoisted_114),
                        _hoisted_115,
                        (__props.rowItem.customerProductProp)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_116, _toDisplayString(_unref(t)('商品规格')) + ":" + _toDisplayString(__props.rowItem.customerProductProp), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  ([1, 2, 3].includes(__props.rowItem.customerOperateType))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_117, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productSkuList.value, (v, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            (__props.rowItem.customerProductSku === v.productSku)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(v.props), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 4)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_119, [
                        _createElementVNode("span", {
                          innerHTML: _unref(cT)('换个链接')
                        }, null, 8, _hoisted_120),
                        _createElementVNode("a", {
                          href: __props.rowItem.customerProductLink,
                          target: "_blank"
                        }, "(" + _toDisplayString(__props.rowItem.customerProductLink) + ")", 9, _hoisted_121),
                        _hoisted_122,
                        (__props.rowItem.customerProductProp)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_123, _toDisplayString(_unref(t)('商品规格')) + ":" + _toDisplayString(__props.rowItem.customerProductProp), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 6)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_124, [
                        _createElementVNode("span", {
                          innerHTML: _unref(cT)('同款链接')
                        }, null, 8, _hoisted_125),
                        _createElementVNode("a", {
                          target: "_blank",
                          href: __props.rowItem.purchaseUserProductLink
                        }, _toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ")", 9, _hoisted_126),
                        _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp?.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 7)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_127, [
                        _createTextVNode(_toDisplayString(_unref(cT)('类似款链接')) + " ", 1),
                        _createVNode(AppLink, {
                          to: __props.rowItem.purchaseUserProductLink,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ") ", 1)
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 8 && __props.rowItem.type === 4)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 14,
                        innerHTML: _unref(t)('等待原链接')
                      }, null, 8, _hoisted_128))
                    : _createCommentVNode("", true),
                  _hoisted_129,
                  (__props.rowItem.customerOperateType == 8 && (__props.rowItem.type === 6) || (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 4))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_130, [
                        _createElementVNode("span", {
                          innerHTML: _unref(cT)('下单原链接')
                        }, null, 8, _hoisted_131)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType == 10 && __props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 6)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_132, [
                        _createElementVNode("span", {
                          innerHTML: _unref(cT)('下单原链接')
                        }, null, 8, _hoisted_133)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType === 16)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_134, _toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）正常发货')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType === 17)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_135, _toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType === 18)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_136, _toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.customerOperateType === 19)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_137, _toDisplayString(_unref(t)('不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）')), 1))
                    : _createCommentVNode("", true),
                  (__props.rowItem.abnormalProcessType === 1 && __props.rowItem.abnormalProcessDetailType === 22)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_138, "(" + _toDisplayString(_unref(t)('超过60天用户未处理，系统已自动处理')) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                (__props.rowItem.customerOperateType === 18)
                  ? (_openBlock(), _createBlock(productTable, {
                      key: 0,
                      tableData: tableData.value,
                      type: 3,
                      long: true,
                      customerOperateType: 18,
                      style: {"margin-top":"10px"}
                    }, null, 8, ["tableData"]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: groupVisible.value,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((groupVisible).value = $event)),
          "custom-class": "problem-group-dialog"
        }, {
          default: _withCtx(() => [
            _hoisted_141,
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("img", { src: _unref(warningIcon) }, null, 8, _hoisted_143),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('「已取消」或「已发货」或「待发货」或「触发异常联络未处理」的商品无法再次选择')), 1)
            ]),
            _createVNode(productTable, {
              tableData: tableData.value,
              customerOperateType: customerOperateType.value
            }, null, 8, ["tableData", "customerOperateType"]),
            _createElementVNode("div", _hoisted_144, [
              _createVNode(_component_el_button, {
                onClick: _cache[47] || (_cache[47] = ($event: any) => (groupVisible.value = false)),
                style: {"width":"100px","height":"40px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submit,
                style: {"width":"100px","height":"40px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: smallQuickDetailVisible.value,
          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((smallQuickDetailVisible).value = $event)),
          "append-to-body": "",
          width: "640px",
          "custom-class": "small-quick-detail-dialog",
          "close-on-click-modal": false
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: closeSmallQuickDetail }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_145,
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("table", null, [
                _hoisted_147,
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_148,
                    _createElementVNode("th", null, _toDisplayString(_unref(t)('客户SKU')), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(isJA)() ? '商品規格' : _unref(t)('商品规格')), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(t)('数量')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smallQuickResult.value?.skuList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `${item.productSku || index}-${item.customerProductSku || index}`
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.productSku || '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(item.customerProductSku || '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(formatSmallQuickProductSpec(item)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.num ?? '-'), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["drawer", "title"]),
    _createVNode(EditMeasureSize, {
      ref: (_value, _refs) => {
        _refs['editMeasureSizeRef'] = _value
        editMeasureSizeRef.value = _value
      },
      onSuccess: _ctx.editSuccess
    }, null, 8, ["onSuccess"])
  ], 64))
}
}

})